import { render, staticRenderFns } from "./AddLink.vue?vue&type=template&id=83cc5388&scoped=true&"
import script from "./AddLink.vue?vue&type=script&lang=js&"
export * from "./AddLink.vue?vue&type=script&lang=js&"
import style0 from "./AddLink.vue?vue&type=style&index=0&id=83cc5388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cc5388",
  null
  
)

export default component.exports